import React from 'react';

import SignInAndPWAButtons from '../SignInAndPWAButtons';
import MobileInstallButtons from '../MobileInstallButtons';

function LandingCta(props) {
  return (
    <div className="pb-12 text-center">
      <SignInAndPWAButtons align="center" isMobile={props.isMobile}>
        {props.buttonContent}
      </SignInAndPWAButtons>
      <MobileInstallButtons isMobile={props.isMobile} />
    </div>
  );
}

export default LandingCta;
